// extracted by mini-css-extract-plugin
export default {"text":"ewGtb","seat":"rXhVb","mobile":"wzHNA","selected":"_9HyGh","wholeTableReservation":"oYMII"};